import { CUSTOMER_APIS } from "@/api_framework/api_config";
import {
  ICustomerServiceCallConnectRequest,
  ICustomerServiceCallConnectResponse,
} from "@/api_framework/api_modals/Users";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

AxiosCurlirize(axios, () => {});

type ICustomerServiceCallConnectResult = {
  status: boolean;
  message: string;
  data?: unknown;
};

export const useCustomerServiceCallConnectAPI = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (payload: ICustomerServiceCallConnectRequest): Promise<ICustomerServiceCallConnectResult> => {
      try {
        const endpoint = CUSTOMER_APIS?.EXOTEL_CONNECT_USER_PROFILE?.baseURL;

        if (!endpoint) {
          const message = "Service call endpoint is missing";
          toast.error(message);
          return { status: false, message };
        }

        if (!payload?.from_number || !payload?.to_number) {
          const message = "from_number and to_number are required";
          toast.error(message);
          return { status: false, message };
        }

        setIsLoading(true);
        const res = await axios.post<ICustomerServiceCallConnectResponse>(endpoint, payload, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        const response: ICustomerServiceCallConnectResult = {
          status: Boolean(res?.data?.status),
          message: res?.data?.message ?? "",
          data: res?.data?.data,
        };

        if (response.status && response.message) {
          toast.success(response.message);
        } else if (!response.status && response.message) {
          toast.error(response.message);
        }

        return response;
      } catch (error: unknown) {
        const axiosError = error as AxiosError<ICustomerServiceCallConnectResponse>;
        sendCurl(axiosError?.config?.["curlCommand"]);
        const message = axiosError?.response?.data?.message || axiosError?.message || "Request failed";
        toast.error(message);
        return { status: false, message };
      } finally {
        setIsLoading(false);
      }
    },
    [sendCurl],
  );

  return { execute, isLoading };
};
